<template>
  <BaseModal
    small
    useForm
    :heading="$t('wavy_onboarding.migrate_website.heading')"
    @close="emit('close')"
    @submit="submit"
  >
    <FirstStep v-if="!responseState" />
    <SuccessStep v-if="responseState === 'MIGRATED'" />
    <ErrorStep
      v-if="responseState === WavyWebsiteMigrationStateEnum.Error || responseState === WavyWebsiteMigrationStateEnum.NoWebsite"
      :noWebsite="responseState === WavyWebsiteMigrationStateEnum.NoWebsite"
    />
    <template #footer>
      <BaseButton
        :submitForm="!responseState"
        :loading="loading"
        :routerLink="buttonLink || undefined"
        @click="!responseState ? undefined : emit('close')"
        v-test="'migrate-website-button'"
      >
        {{ buttonText }}
      </BaseButton>
    </template>
  </BaseModal>
</template>

<script
  setup
  lang="ts"
>
import { useMutation } from '@vue/apollo-composable';
import gql from 'graphql-tag';
import { useI18n } from 'vue-i18n';
import { WavyWebsiteMigrationStateEnum } from '@/types';
import ErrorStep from './ErrorStep.vue';
import FirstStep from './FirstStep.vue';
import SuccessStep from './SuccessStep.vue';

const emit = defineEmits(['close', 'submit']);

const { mutate, loading } = useMutation(gql`
  mutation migrateWavyWebsite($input: MigrateWavyWebsiteInput!) {
    migrateWavyWebsite(input: $input) {
      state
    }
  }
`);

const { t } = useI18n();

const responseState = ref<WavyWebsiteMigrationStateEnum | null>(null);

const buttonText = computed(() => {
  if (!responseState.value) {
    return t('wavy_onboarding.migrate_website.button');
  }
  if (responseState.value === 'MIGRATED') {
    return t('wavy_onboarding.migrate_website.success.button');
  } else {
    return t('global.done');
  }
});

const buttonLink = computed(() => {
  if (responseState.value === 'MIGRATED') {
    return { name: 'online-website-service' };
  }
  return null;
});

const submit = () => {
  if (responseState.value) {
    return;
  }

  mutate({
    input: {},
  }).then(({ data: { migrateWavyWebsite } }) => {
    responseState.value =
      migrateWavyWebsite.state as WavyWebsiteMigrationStateEnum;
    emit('submit');
  });
};
</script>
